import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const CreditApplication = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://form.jotform.com/jsform/250916483785267";
    script.async = true;
    document.getElementById("jotform-container").appendChild(script);
  }, []);
  return (
    <div>
      <Helmet>
        <title>Canco Petroleum – Customer Credit Application Form</title>
        <meta
          name="description"
          content="Secure customer credit application form for Canco Petroleum Ltd."
        />
      </Helmet>
      <div id="jotform-container"></div>
    </div>
  );
};

export default CreditApplication;
